import type { AsyncData } from '#app';
import type {
  IModelListQueryParamsRequest,
  IModelResponse,
} from '~/services/base/dto/base.dto';
import type {
  IModelCreateQuotaRequest,
  IModelQuotaDepartmentResponse,
  IModelQuotaDetailResponse,
  IModelQuotaListResponse,
  IModelQuotaResponse,
  IModelUserQuotaBySuperAdminResponse,
} from './dto/quota.dto';
import type { IModelSubDepartmentListResponse } from './dto/quota-sub-department.dto';
import type { IModelQuotaSuperAdminListQueryParamsRequest } from './dto/super-admin-quota.dto';

export class QuotaRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getQuota(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelQuotaListResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/list/quota-list`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getQuotaById(
    id: string | number
  ): Promise<AsyncData<IModelResponse<IModelQuotaDetailResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/quota-limit/${id}`,
      this.configService
    );
    return dataResult;
  }

  async createQuota(
    params: IModelCreateQuotaRequest
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-master`,
      this.configService,
      {
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async updateQuota(
    params: IModelCreateQuotaRequest
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-limit/bulk`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async updateOverallQuota(
    params: any
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-department`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

    async getQuotaDepartment(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelQuotaDepartmentResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/list/quota-list`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

    async getQuotaSupDepartment(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelSubDepartmentListResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/list/quota-list`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getOverallQuota(): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-department/dept-code`,
      this.configService
    );
    return dataResult;
  }

  async getSupDepartmentQuotaBySuperAdmin(params: IModelQuotaSuperAdminListQueryParamsRequest): Promise<AsyncData<IModelResponse<IModelSubDepartmentListResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/list/admin-sub-department`,
      this.configService, { params}
    );
    return dataResult;
  }

  async getFunctionCodeQuotaBySuperAdmin(params: IModelQuotaSuperAdminListQueryParamsRequest): Promise<AsyncData<IModelResponse<IModelSubDepartmentListResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/list/admin-function-code`,
      this.configService, { params}
    );
    return dataResult;
  }

  async getUserQuotaBySuperAdmin(params: IModelQuotaSuperAdminListQueryParamsRequest): Promise<AsyncData<IModelResponse<IModelUserQuotaBySuperAdminResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/quota-association/list/admin-user`,
      this.configService, { params}
    );
    return dataResult;
  }
}
